import { render, staticRenderFns } from "./RolesPage.vue?vue&type=template&id=7ae05991&"
import script from "./RolesPage.vue?vue&type=script&lang=js&"
export * from "./RolesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae05991')) {
      api.createRecord('7ae05991', component.options)
    } else {
      api.reload('7ae05991', component.options)
    }
    module.hot.accept("./RolesPage.vue?vue&type=template&id=7ae05991&", function () {
      api.rerender('7ae05991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/RolesPage.vue"
export default component.exports